import { ISelectOptions } from "aw-combobox"
import { GraphLine, IChartOptions } from "aw-graph-chartjs"
import { useEffect, useRef, useState } from "react"
import { Form } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useOutletContext } from "react-router-dom"
import AWSelect from "../components/aw-select/AWSelect"
import { StatCard } from "../components/StatCard/StatCard"
import { useTheme } from "../utils/contexts/ThemeContext"
import caeGraph1Data from '../utils/data/caeGraph1Data.json'
import caeGraph2Data from '../utils/data/caeGraph2Data.json'
import { IOutletContext } from "../utils/interfaces/IOutletContext"
import { Instalation } from "../utils/models/Instalation"
import { Machine } from "../utils/models/Machine"
import { selectUser } from "../utils/redux/userSlice"



const CAEModulePage = () => {
    const { t } = useTranslation()
    const context: IOutletContext = useOutletContext()
    // Fechas para la parte superior
    const [iniDate, setIniDate] = useState("2025-03-01")
    const [finDate, setFinDate] = useState("2025-03-07")

    // Fechas para la parte inferior
    const [iniDateAfter, setIniDateAfter] = useState("2025-05-01")
    const [finDateAfter, setFinDateAfter] = useState("2025-05-01")
    const [dark, setDark] = useState(false)

    const [graphOptions1, setGraphOptions1] = useState<IChartOptions[]>([]);
    const [graphData1, setGraphData1] = useState<any[]>([]);
    const [selectedGraphOptions1, setSelectedGraphOptions1] = useState<IChartOptions[]>([]);

    const [graphOptions2, setGraphOptions2] = useState<IChartOptions[]>([]);
    const [graphData2, setGraphData2] = useState<any[]>([]);
    const [selectedGraphOptions2, setSelectedGraphOptions2] = useState<IChartOptions[]>([]);

    const theme = useTheme()
    const searchButton = useRef<HTMLButtonElement>(null)

    const buildGraphOptions1 = () => {
        const options = [
            { label: t('kWAvgBefore'), key: 'g1_avg_before', color: 'rgb(5, 5, 5)', units: "kW", minValue: 0, maxValue: 35, value: 0 },
            { label: t('kWAfter'), key: 'g1_after', color: 'rgb(252, 190, 57)', units: "kW", minValue: 0, maxValue: 35, value: 1 },
            { label: t('kWBeforeP1'), key: 'g1_before_1', color: 'rgb(175, 175, 175)', units: "kW", minValue: 0, maxValue: 35, hideLegend: true, value: 2 },
            { label: t('kWBeforeP2'), key: 'g1_before_2', color: 'rgb(175, 175, 175)', units: "kW", minValue: 0, maxValue: 35, hideLegend: true, value: 3 },
            { label: t('kWBeforeP3'), key: 'g1_before_3', color: 'rgb(175, 175, 175)', units: "kW", minValue: 0, maxValue: 35, hideLegend: true, value: 4 },
            { label: t('kWBeforeP4'), key: 'g1_before_4', color: 'rgb(175, 175, 175)', units: "kW", minValue: 0, maxValue: 35, hideLegend: true, value: 5 },
            { label: t('kWBeforeP5'), key: 'g1_before_5', color: 'rgb(175, 175, 175)', units: "kW", minValue: 0, maxValue: 35, hideLegend: true, value: 6 },
            { label: t('kWBeforeP6'), key: 'g1_before_6', color: 'rgb(175, 175, 175)', units: "kW", minValue: 0, maxValue: 35, hideLegend: true, value: 7 },
            { label: t('kWBeforeP7'), key: 'g1_before_7', color: 'rgb(175, 175, 175)', units: "kW", minValue: 0, maxValue: 35, hideLegend: true, value: 8 },
        ]
        setGraphOptions1(options);
        setSelectedGraphOptions1(options);
    }

    const buildGraphOptions2 = () => {
        const options = [
            { label: t('kWhAvgBefore'), key: 'g1_avg_before', color: 'rgb(5, 5, 5)', units: "kWh", minValue: 0, maxValue: 6000, value: 0 },
            { label: t('kWhAfter'), key: 'g1_after', color: 'rgb(252, 190, 57)', units: "kWh", minValue: 0, maxValue: 6000, value: 1 },
            { label: t('kWhBeforeP1'), key: 'g1_before_1', color: 'rgb(175, 175, 175)', units: "kWh", minValue: 0, maxValue: 6000, hideLegend: true, value: 2 },
            { label: t('kWhBeforeP2'), key: 'g1_before_2', color: 'rgb(175, 175, 175)', units: "kWh", minValue: 0, maxValue: 6000, hideLegend: true, value: 3 },
            { label: t('kWhBeforeP3'), key: 'g1_before_3', color: 'rgb(175, 175, 175)', units: "kWh", minValue: 0, maxValue: 6000, hideLegend: true, value: 4 },
            { label: t('kWhBeforeP4'), key: 'g1_before_4', color: 'rgb(175, 175, 175)', units: "kWh", minValue: 0, maxValue: 6000, hideLegend: true, value: 5 },
            { label: t('kWhBeforeP5'), key: 'g1_before_5', color: 'rgb(175, 175, 175)', units: "kWh", minValue: 0, maxValue: 6000, hideLegend: true, value: 6 },
            { label: t('kWhBeforeP6'), key: 'g1_before_6', color: 'rgb(175, 175, 175)', units: "kWh", minValue: 0, maxValue: 6000, hideLegend: true, value: 7 },
            { label: t('kWhBeforeP7'), key: 'g1_before_7', color: 'rgb(175, 175, 175)', units: "kWh", minValue: 0, maxValue: 6000, hideLegend: true, value: 8 },
        ]
        setGraphOptions2(options);
        setSelectedGraphOptions2(options);
    }

    useEffect(() => {
        context.setState(t("CAE"))
    }, [context, t])

    useEffect(() => {
        buildGraphOptions1();
        buildGraphOptions2();
    }, [t]);

    useEffect(() => {
        setGraphData1(caeGraph1Data);
        setGraphData2(caeGraph2Data);
    }, []);

    useEffect(() => {
        setDark(theme.theme === 'dark' ? true : false)
    }, [theme])

    // Arrays para los selects
    const clientesOptions: ISelectOptions[] = Array.from({ length: 10 }, (_, i) => ({ label: `${t('Client')} ${i + 1}`, value: i + 1 }));
    const instalacionesOptions: ISelectOptions[] = Array.from({ length: 10 }, (_, i) => ({ label: `${t('Installation')} ${i + 1}`, value: i + 1 }));
    const medidoresOptions: ISelectOptions[] = Array.from({ length: 10 }, (_, i) => ({ label: `${t('Meter')} ${i + 1}`, value: i + 1 }));

    // Fecha de actuación fija para el ejemplo
    const actuacionDate = "15/04/2025";

    return (
        <>
            <div
                className='row border-0 ms-2 me-2'
                style={{ maxWidth: "100%" }}
            >
                <div className='col-12 col-md-12 p-1'>
                    <div className={`p-2 rounded-1 search-bar-container `} style={{ backgroundColor: `var(--background-secondary)` }}>
                        {/* Primera fila */}
                        <div className='d-flex align-items-center flex-column flex-md-row justify-content-md-between gap-md-0 gap-1' >
                            <div className='d-flex w-100 w-md-auto flex-sm-grow-0 flex-sm-row flex-column  gap-1'>
                                <div className="d-flex flex-fill gap-1">
                                    <div className='min-w-125 w-50 flex-sm-fill flex-grow-0'>
                                        <AWSelect dark={dark} onChange={() => null} options={clientesOptions} value={clientesOptions[0]} />
                                    </div>
                                    <div className='flex-fill flex-md-grow-0 w-50 min-w-125'>
                                        <AWSelect dark={dark} onChange={() => null} options={instalacionesOptions} value={instalacionesOptions[0]} />
                                    </div>
                                    <div className='flex-fill flex-md-grow-0 w-50 min-w-125'>
                                        <AWSelect dark={dark} onChange={() => null} options={medidoresOptions} value={medidoresOptions[0]} />
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex flex-fill w-sm-auto w-100 flex-sm-row flex-column justify-content-end gap-1' >
                                <div className='d-flex flex-fill flex-md-grow-0 gap-1 align-items-center'>
                                    <label className='me-2 mb-0' style={{ whiteSpace: 'nowrap' }}>{t('PeriodBefore')}</label>
                                    <div className='flex-fill '>
                                        <Form.Control name='iniDate' className={dark ? "date-picker dark" : "date-picker"} type='date' value={iniDate} onChange={() => { }} />
                                    </div>
                                    <div className='flex-fill'>
                                        <Form.Control name='finDate' className={dark ? "date-picker dark" : "date-picker"} type='date' value={finDate} onChange={() => { }} />
                                    </div>
                                </div>
                                {/* Espacio transparente para alinear con el botón de la segunda fila */}
                                <div className='ms-auto ms-sm-0 d-flex align-items-center justify-content-center' style={{ width: 36, height: 36, opacity: 0 }}>
                                    <button style={{ width: 36, height: 36, pointerEvents: 'none' }} className={`btn-Custom btn-IDGreen mt-0`}>
                                        <i className='bi bi-search'></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* Segunda fila */}
                        <div className='d-flex align-items-center flex-column flex-md-row justify-content-md-between gap-md-0 gap-1 mt-2'>
                            <div className='d-flex w-100 w-md-auto flex-sm-grow-0 flex-sm-row flex-column gap-1 align-items-center'>

                                {/* Botón Descargar CAE en el centro */}
                                <div className='mx-0 me-5'>
                                    <button className={`btn-Custom btn-IDGreen mt-0`}>
                                        {t('DownloadCAE')}
                                    </button>
                                </div>
                                <div className='d-flex align-items-center'>
                                    <label className='mb-0 fw-bold' style={{ whiteSpace: 'nowrap' }}>{t('ActuationDate')}: {actuacionDate}</label>
                                </div>
                            </div>
                            <div className='d-flex flex-fill w-sm-auto w-100 flex-sm-row flex-column justify-content-end gap-1' >
                                <div className='d-flex flex-fill flex-md-grow-0 gap-1 align-items-center'>
                                    <label className='me-2 mb-0' style={{ whiteSpace: 'nowrap' }}>{t('PeriodAfter')}</label>
                                    <div className='flex-fill '>
                                        <Form.Control name='iniDateAfter' className={dark ? "date-picker dark" : "date-picker"} type='date' value={iniDateAfter} onChange={() => { }} />
                                    </div>
                                    <div className='flex-fill'>
                                        <Form.Control name='finDateAfter' className={dark ? "date-picker dark" : "date-picker"} type='date' value={finDateAfter} onChange={() => { }} />
                                    </div>
                                </div>
                                <div className='ms-auto ms-sm-0 d-flex align-items-center justify-content-center' style={{ width: 36, height: 36 }}>
                                    <button ref={searchButton} style={{ width: 36, height: 36 }} onClick={() => { }} className={`btn-Custom btn-IDGreen mt-0`}>
                                        <i className='bi bi-search'></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row border-0 my-2 ms-2 me-2' style={{ maxWidth: "100%" }}>
                <div className='col-6 col-md-3 py-1 ps-1 pe-2'>
                    <StatCard
                        icon="bi bi-lightning-charge"
                        title={t('StatCardTitle_AhorroEnergetico')}
                        value="2036,8 kWh"
                        percentage={39.8}
                        trend="up"
                        infoText={t('StatCardInfo_AhorroEnergetico')}
                    />
                </div>
                <div className='col-6 col-md-3 py-1 px-2'>
                    <StatCard
                        icon="bi bi-leaf"
                        title={t('StatCardTitle_ReduccionCO2')}
                        value="230,2 kg CO2"
                        percentage={22.5}
                        trend="up"
                        infoText={t('StatCardInfo_ReduccionCO2')}
                    />
                </div>
                <div className='col-6 col-md-3 py-1 px-2'>
                    <StatCard
                        icon="bi bi-currency-euro"
                        title={t('StatCardTitle_AhorroEconomico')}
                        value="28,77 €"
                        percentage={12.5}
                        trend="up"
                        infoText={t('StatCardInfo_AhorroEconomico')}
                    />
                </div>
                <div className='col-6 col-md-3 py-1 ps-2 pe-1'>
                    <StatCard
                        icon="bi bi-speedometer2"
                        title={t('StatCardTitle_RatioEficiencia')}
                        value="3,34 kWh/u"
                        percentage={39.8}
                        trend="up"
                        infoText={t('StatCardInfo_RatioEficiencia')}
                    />
                </div>
            </div>
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: "100%" }}>
                <div className='col-12 col-md-6 p-1 pe-2' style={{ height: '500px' }}>

                    <GraphLine
                        containerTitle={`${t('AbsoluteConsumption')}`}
                        refresh={false}
                        showSelect={false}
                        showDots={false}
                        options={graphOptions1}
                        initialSelectedOptions={selectedGraphOptions1}
                        data={graphData1}
                        onChangeSelectedOptions={setSelectedGraphOptions1}
                        spinnerColor='var(--SpinnerColor)'
                    ></GraphLine>
                </div>
                <div className='col-12 col-md-6 p-1 ps-2' style={{ height: '500px' }}>
                    <GraphLine
                        containerTitle={`${t('CumulativeConsumption')}`}
                        refresh={false}
                        showSelect={false}
                        showDots={false}
                        options={graphOptions2}
                        initialSelectedOptions={selectedGraphOptions2}
                        data={graphData2}
                        onChangeSelectedOptions={setSelectedGraphOptions2}
                        spinnerColor='var(--SpinnerColor)'
                    ></GraphLine>
                </div>
            </div>
        </>
    )
}
export default CAEModulePage
